import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxDialogOptions } from './messagebox-dialog';


@Component({
    selector: 'app-messagebox-dialog-component',
    styleUrls: ['./messagebox-dialog.component.scss'],
    templateUrl: './messagebox-dialog.component.html',
})
export class MessageBoxDialogComponent implements OnInit {
    TitleText?: string;
    MessageText!: string;
    OKText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;    

    constructor(
        private dialogRef: MatDialogRef<MessageBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: MessageBoxDialogOptions
    ) {
        const self = this;
        self.TitleText = data.TitleText || 'Information';
        self.MessageText = data.MessageText || '';
        self.OKText = data.OKText || 'OK';
        self.IconColor = data.IconColor || 'black';
        self.IconName = data.IconName || 'info';
        self.ShowIcon = data.ShowIcon || false;
    }

    ngOnInit() {}

    OKHandler() {
        this.dialogRef.close(true);
    }
}
